<template>
    <div>
        <el-dialog title="新增服务规格属性" :visible="newDialogVisible" width="50%" @close="handleCloseAdd()">
            <div class="content">
                <el-form ref="ruleForm" label-width="120px">
                    <!-- 规格属性 -->
                    <div class="first-content">
                        <div class="pro-tile">
                            <span>规格属性：</span>
                        </div>
                        <el-table :data="specificationTable" class="column-box"
                            style="width: 100%;max-height: 350px;overflow-y: auto;">
                            <el-table-column prop="img" label="规格图片">
                                <template slot-scope="scope">
                                    <el-upload class="avatar-uploader avatar-uploader-table" :action="upLoadApi"
                                        :show-file-list="false" :on-success="handleSkuImg" :headers="uploadHeaders">
                                        <img v-if="scope.row.img" :src="scope.row.img" class="avatara">
                                        <i v-else class="el-icon-plus avatara-uploader-icon"
                                            @click="handleSkuImgI(scope.$index)"></i>
                                    </el-upload>
                                </template>
                            </el-table-column>
                            <el-table-column prop="title" label="规格标题">
                                <template slot-scope="scope">
                                    <el-input @change="change" type="text" v-model="scope.row.title" placeholder="请输入" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="money" label="售价">
                                <template slot-scope="scope">
                                    <el-input @change="money" type="text" v-model="scope.row.money" placeholder="请输入" />
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="sort" label="排序">
                                <template slot-scope="scope">
                                    <el-input @change="" type="text" v-model="scope.row.sort" placeholder="请输入" />
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="shareMoney" label="佣金">
                                <template slot-scope="scope">
                                    <el-input @change="shareMoney" type="text" v-model="scope.row.shareMoney" placeholder="请输入" />
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseAdd()">取 消</el-button>
                <el-button type="primary" @click="submitForm()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import Editor from 'wangeditor'
import serveApi from '../serve.js'
export default {

    data() {
        return {
            newDialogVisible: false,
            id: '',
            ruleForm:{
            title: '',
            serviceId: '',
            img: '',
            money: '',
            shareMoney: '',
            },
          
            // token
            uploadHeaders: { "token": localStorage.getItem('token') },
            // 状态
            newAddEdit: '',
            // 商户ID
            busId: '',
            specificationTable: [
                {
                    img: '',
                    title: '',
                    money: '',
                    shareMoney: '',
                    sort: '',
                }
            ],
        };
    },
    created() {
        // this.addServiceRule(this.serviceId)
    },
    mounted() {
        // 上传地址拼接
        this.upLoadApi = serveApi.api + '/admin/file/upload'
        // 获取服务列表
        this.getServeList()
    },
    watch: {
    },
    components: {
    },
    methods: {
        /**
         * 获取服务列表
         */
        getServeList() {
            let businId = this.$store.state.businServeID
            let list = []
            let params = {
                pid: 0,
                // 1：商户服务类型，2：商品类型,3：第三方服务
                type: 1,
            }
            this.$api.production.listAll(params).then(res => {
                res.data.data.forEach(e => {
                    let data = []
                    e.atCategoryInfos.forEach(obj => {
                        businId.forEach(son => {
                            if (Number(son) === Number(obj.id)) {
                                data.push(obj)
                            }
                        })
                    })
                    if (!data.length) return
                    let param = {
                        id: e.atCategoryInfo.id,
                        title: e.atCategoryInfo.title,
                        atCategoryInfos: data,
                    }
                    list.push(param)
                })
                this.typeList = list
            })
        },
        /**
         * 块级联动
         */
        changeCascader(e) {
            // 取最后一级value值
            this.ruleForm.categoryId = e[1]
        },
        /**
         * 调整每天条数
         */
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        /**
         * 当前页
         */
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        /**
         * 打开弹窗
         */
        openDia(item,e) {          
            this.serviceId = item.id
            // this.id = item.id
            console.log(item,e,this.serviceId,'0000')
            if(e){
                this.specificationTable=e
            }else{
                this.specificationTable=[ {
                    img: '',
                    title: '',
                    money: '',
                    shareMoney: '',
                    sort: '',
                }]
                console.log( item,e,' this.specificationTable')
            }
            // if (e.id === '') {
            //     this.newAddEdit = e.id
            //     this.busId = e.busId
            // } else {
            //     this.newAddEdit = e.id
            //     this.busId = e.item.busId
            //     Object.assign(this.ruleForm, {
            //         title: e.item.title,
            //         serviceIntroduction: e.item.serviceIntroduction,
            //         categoryId: e.item.categoryId,
            //         startPrice: e.item.startPrice,
            //         imageUrl: e.item.cover,
            //         // imageUrlPro: e.item.imgList[0],
            //         isOnce: e.item.isOnce,
            //         content: e.item.content,
            //         couponPrice: e.item.couponPrice,
            //     })
            // }
            this.newDialogVisible = true
            // this.getServeList()
        },
        /**
         * 关闭弹窗
         */
        handleCloseAdd() {
            // 销毁编辑器
            // this.editor.destroy()
            this.dialogImageUrl = []
            this.fileList = []
            this.newDialogVisible = false
        },
        // 添加服务规格
        addServiceRule(e) {
            let param = {
                // 服务类目
                serviceId: e.id,
            }
            console.log(e.id, 'jjjjjjj')
            this.$api.merchant.serviceSpecList(param).then(res => {
                console.log(res, 'resresres')
            })
        },
        change(e){
            this.ruleForm.title=e
            console.log(e,'eeeeeeeee')

        },
        money(e){
            this.ruleForm.money=e
        },
        shareMoney(e){
            this.ruleForm.shareMoney=e
        },
        /**
         * 点击确认
         */
        submitForm() {
            let params = {
                // 服务id
                id: this.id,
                img: this.ruleForm.img,
                // 服务名称
                title: this.ruleForm.title,
                // 服务类目
                serviceId: this.serviceId,
                money: this.ruleForm.money,
                shareMoney:this.ruleForm.shareMoney,
                status: 1,
                sort: 1
            }
            this.$api.merchant.serviceSpecAdd(params).then(res => {
                console.log(res)
            })
            this.newDialogVisible = false
        },
        /**
        * 删除
        */
        del(e) {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$message({
                    type: "success",
                    message: `已成功删除`,
                });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除",
                });
            });
        },
        /**
         * 上传规格
         */
        uploadSpec() {
            let fkeyData = ''
            this.specsData.map((e, eindex) => {
                if (eindex === 0) {
                    fkeyData = e.id
                } else {
                    fkeyData = fkeyData + ',' + e.id
                }
                return
            })
            // 清空
            // this.specificationTable = []
            this.resultSku.map(res => {
                let params = {
                    // 服务id
                id: this.id,
                img:  this.specificationTable[this.skuIndex].img,
                // 服务名称
                title: this.ruleForm.title,
                // 服务类目
                serviceId: this.serviceId,
                money: 20,
                shareMoney: 1,
                status: 1,
                sort: 1
                }
                this.specificationTable.push(params)
                return
            })
            // console.log(this.specificationTable, 'specificationTable')
        },
        /**
         * sku图片选择
         */
        handleSkuImg(res, file) {
            this.specificationTable[this.skuIndex].img = res.data
            this.ruleForm.img=res.data
            console.log(this.specificationTable, 'specificationTable')
        },
        /**
         * sku点击储存临时下标
         */
        handleSkuImgI(index) {
            this.skuIndex = index
            console.log(index, 'skuIndex')
        },
        /**
         * 封面图片上传
         */
        handleAvatarSuccess(res, file) {
            this.ruleForm.imageUrl = res.data
        },
        /**
         * 商品图片上传
         */
        handleAvatarSuccessPro(res, file) {
            this.ruleForm.imageUrlPro = res.data
            this.dialogImageUrl.push(res.data)
        },
        /**
         * 商品轮播图移除
         */
        handleRemove(file) {
            let img = file.response.data
            this.dialogImageUrl.map((e, index) => {
                if (e === img) {
                    this.dialogImageUrl.splice(index, 1)
                }
                return
            })
            if (this.dialogImageUrl.length === 0) {
                this.ruleForm.imageUrlPro = ''
            }
        },
    }
};
</script>
  
<style  scoped>
.first-title {
    display: flex;
    align-items: center;
}

.first-title-icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-bottom: 10px;
    margin-right: 10px;
    background: #FF5722;
}

.first-title-word {
    flex: 1;
    box-sizing: border-box;
    padding-bottom: 10px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    border: 1px dashed #aaa;
    margin-top: 10px;
}

.avatar {
    width: 150px;
    height: 150px;
    display: block;
    margin-top: 10px;
}

.avatar-uploader-img-list {
    /* width: 400px; */
    display: flex;
}

.avatar-uploader-img-list>>>.el-upload--picture {
    margin-right: 20px;
}

.avatar-uploader-img-list>>>.el-upload-list--picture {
    width: 400px;
}

.product-detail {
    margin-top: 20px;
}

.couponPrice {
    display: flex;
    justify-content: start;
    align-items: center;
}

/* 规格属性 */
.first-content {
    box-sizing: border-box;
    padding-top: 10px;
}

.img-upload {
    display: flex;
    flex-direction: column;
}

.img-upload-list {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}

.avatar-uploader-table {
    display: flex;
    align-items: center;
    padding: 5px 0;
}

.avatar-uploader-img-list {
    width: 400px;
}

.avatar-uploader {
    padding: 5px 0;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    border: 1px dashed #aaa;
    text-align: center;
}

.avatara-uploader-icon {
    font-size: 14px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border: 1px dashed #aaa;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.avatara {
    width: 50px;
    height: 50px;
    display: block;
}

.pro-tile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px;
}

.pro-tile-banner {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
}

.specs-input>>>.el-input__inner {
    border: none !important;
}

.specs-input>>>.el-input__inner:hover {
    background: rgb(245, 247, 250);
}

.column-box>>>.el-table__cell {
    padding: 0;
}

.column-box>>>.cell {
    padding-left: 0;
    padding-right: 0;
}

.banner-btn {
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;
    padding: 0 15px 15px;
}

.product-detail {
    margin-top: 20px;
}

.img-upload-box {
    display: flex;
}
</style>
  


// WEBPACK FOOTER //
// src/components/addServiceRule.vue